import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject, Subscription, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CxDataGridService {
    constructor (private http: HttpClient) { }

    updateViewName (paylod: { id: string, name: string } = { id: '', name: ''}) {
        const url = `/datagrid/views_name/${paylod.id}`;
        return this.http.patch(url, paylod);
    }

    deleteView (id: string) {
        const url = `/datagrid/views/${id}`;
        return this.http.delete(url);
    }

    updateView (module: string, paylod: any = {}) {
        const url = '/datagrid/views';
        paylod.module = module;
        return this.http.put(url, paylod);
    }

    updateQuickFilters (paylod: any = {}) {
        const url = `/datagrid/quick_filters/${paylod.id}`;
        paylod.module = module;
        return this.http.patch(url, paylod);
    }

    createView (module: string, paylod: any = {}) {
        const url = '/datagrid/views';
        paylod.module = module;
        return this.http.post(url, paylod);
    }

    getViews (module: string, silent = false) {
        const url = `/datagrid/views?module=${module}`;
        if (silent) {
            return this.http.disableLoader().get(url);
        } else {
            return this.http.get(url);
        }
    }

    pinUnpin (pined: boolean, viewId: string) {
        const url = `/datagrid/views_pined`;
        return this.http.patch(url, { pined, id: viewId });
    }

    getFields (module: string) {
        const url = `/datagrid/fields?module=${module}`;
        return of([]); //this.http.get(url);
    }

    getHttp () {
        return this.http;
    }

    asPromise (url: string) {
        return new Promise((resolve: Function, reject: Function) => {
            this.http.get(url).subscribe((data: any) => {
                resolve(data);
            })
        })
    }
}
